<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("edit") }} SMS Campaign</div>
      <router-link class="btn-blue" :to="{ name: 'SMS Campaigns' }"
        >SMS Campaign {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper pt-0">
      <div class="row border-bottom mb-5 pt-3">
        <div
          class="col campaign-step"
          :class="sections.basicInfo ? 'active' : ''"
        >
          <p :class="sections.basicInfo ? 'font-weight-bold text-blue' : ''"
            >1.Basic Info</p
          >
        </div>
        <div
          class="col campaign-step"
          :class="sections.message ? 'active' : ''"
        >
          <p :class="sections.message ? 'font-weight-bold text-blue' : ''"
            >2.Message</p
          >
        </div>
        <!-- 
        <div class="col campaign-step" :class="sections.conversionTracking ? 'active':''">
          <p
            :class="sections.conversionTracking ? 'font-weight-bold text-blue':''"
          >3.Conversion Tracking</p>
        </div>-->

        <div
          class="col campaign-step"
          :class="sections.testCampaign ? 'active' : ''"
        >
          <p :class="sections.testCampaign ? 'font-weight-bold text-blue' : ''"
            >3.Test Campaign</p
          >
        </div>

        <div
          class="col campaign-step"
          :class="sections.previewAndLauch ? 'active' : ''"
        >
          <p
            :class="
              sections.previewAndLauch ? 'font-weight-bold text-blue' : ''
            "
            >4.Preview and Launch</p
          >
        </div>
      </div>

      <!-- BASIC INFO -->
      <div class="col-12 rounded-10 border p-3 mb-4" v-if="sections.basicInfo">
        <div class="row">
          <div class="col-12">
            <div
              class="section-title text-uppercase mb-3"
              style="font-size:18px"
              >Basic Info</div
            >
          </div>
          <div class="col-lg-6 mb-4">
            <div class="input-material">
              <input
                v-validate="'required'"
                name="campaign_name"
                id="campaign_name"
                v-model="campaign_name"
                type="text"
                placeholder="."
              />
              <label>Campaign Name</label>
            </div>
            <p class="error_message">
              <span v-if="errors.has('campaign_name')">{{
                errors.first("campaign_name")
              }}</span>
            </p>
          </div>
          <div class="col-lg-6 mb-4">
            <div class="input-material" v-on:click="selectCampaignTypeModal()">
              <input
                type="text"
                placeholder="."
                v-model="selectedCampaignType.campaign_type_name"
                value="selectedCampaignType"
              />
              <label>Campaign Type</label>
            </div>
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Select Audience</div>
            <multiselect
              v-model="selected_segment"
              track-by="segment_name"
              label="segment_name"
              :options="segments"
              name="campaign_audience"
              id="campaign_audience"
              v-validate="'required'"
            ></multiselect>
            <p class="error_message">
              <span v-if="errors.has('campaign_audience')">{{
                errors.first("campaign_audience")
              }}</span>
            </p>
            <!-- {{selected_segment}} -->
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Campaign Start Date</div>
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate">✖</button> -->
                <Datepicker
                  :monday-first="true"
                  v-model="campaign_start_date"
                />
                <label v-if="campaign_start_date !== ''" class="active"
                  >Start Date</label
                >
                <label v-else>Start Date</label>
              </div>
              <p class="error_message">
                <span v-if="campaign_start_date == ''">{{
                  "Please select start date"
                }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Campaign End Date</div>

            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate">✖</button> -->
                <Datepicker :monday-first="true" v-model="campaign_end_date" />
                <!-- Add class active on date selection -->
                <label v-if="campaign_end_date !== ''" class="active"
                  >End Date</label
                >
                <label v-else>End Date</label>
              </div>
              <p class="error_message">
                <span v-if="campaign_end_date == ''">{{
                  "Please select end date"
                }}</span>
                <span v-if="date_checker">{{
                  "Please select valid date"
                }}</span>
              </p>
            </div>
          </div>

          <div class="col-lg-12 mb-4">
            <div class="mb-2">Select Content Type</div>
            <b-form-radio-group
              v-model="selected_radio"
              :options="options"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
              class="j-radio mb-3"
            ></b-form-radio-group>
            <!-- {{selected_radio}} -->
            <!-- <div>
                <span>Promotional (send only to subscribed user in Audience)</span>
            </div>-->

            <!-- <b-form-radio class="j-radio">
              <div>
                <span>Transactional(send to all users in Audience including those who have unsubscribed)</span>
              </div>
            </b-form-radio>-->
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">SMS Template</div>
            <multiselect
              v-model="selected_sms_template"
              track-by="sms_temp_name"
              label="sms_temp_name"
              :options="smstemplateList"
            ></multiselect>
            <p class="error_message">
              <span v-if="selected_sms_template == null">{{
                "Please select an sms template"
              }}</span>
            </p>
          </div>

          <!-- <div class="col-lg-12 mb-4">
            <div class="mb-2">Audience Type</div>
            <b-form-radio class="j-radio mb-3">
              <div>
                <span>Send to users in single sement</span>
              </div>
            </b-form-radio>

            <b-form-radio class="j-radio">
              <div>
                <span>Send to users in multiple segments and/or Don’t send to users in certain segments</span>
              </div>
            </b-form-radio>
          </div>-->

          <!-- <div class="col-lg-12 mb-4">
            <div class="input-material-textarea">
              <textarea v-model="sms_message" cols="30" rows="10"></textarea>
              <label class="shift-up">Rechable Users SMS</label>
            </div>
          </div>-->

          <div
            class="col-lg-12 mb-4"
            v-if="
              selected_sms_template &&
                selected_sms_template.sms_id == 0 &&
                submittedtemplate === false
            "
          >
            <div class="white-wrapper">
              <div class="row">
                <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                  <div class="input-material">
                    <input
                      v-model="sms_temp_name"
                      v-validate="'required'"
                      placeholder="."
                      type="text"
                      name="smstemplatename"
                      id="smstemplatename"
                    />
                    <label>{{ $t("smstemplate") }} {{ $t("name") }}</label>
                  </div>
                  <p
                    v-if="submitted3 && sms_temp_name == ''"
                    class="error_message"
                  >
                    <span>{{ "Please enter SMS Template Name" }}</span>
                  </p>
                </div>

                <div class="col-lg-12 col-xl-12 mb-4">
                  <div class="d-flex">
                    <div class="input-material-textarea">
                      <textarea
                        v-model="sms_template_content"
                        rows="5"
                        v-validate="'required'"
                        type="text"
                        name="smstext"
                        id="smstext"
                        class="rounded-10"
                      ></textarea>
                      <label>Text</label>
                    </div>
                  </div>
                  <p
                    v-if="submitted3 && sms_template_content == ''"
                    class="error_message"
                  >
                    <span>{{ "Please enter SMS body" }}</span>
                  </p>
                </div>

                <div class="col-lg-6 col-xl-4 align-self-center mb-4">
                  <div class="row">
                    <div class="col-md-3 col-xl-2">
                      <label>{{ $t("active") }}</label>
                    </div>
                    <div class="col-md-9 col-xl-10">
                      <div class="col-4">
                        <b-form-checkbox
                          class="ml-4"
                          v-model="sms_temp_is_active"
                          switch
                          name="check-button"
                        ></b-form-checkbox>
                      </div>
                    </div>
                  </div>
                  <p class="error_message">
                    <span></span>
                  </p>
                </div>

                <div class="col-md-12 text-center mt-4">
                  <button
                    @click.prevent.stop="OnFinalSubmit()"
                    class="btn-blue"
                    >{{ $t("save") }}</button
                  >
                  <button @click.prevent.stop="onResetForm" class="btn-black">{{
                    $t("reset")
                  }}</button>
                  <!-- <b-button
                    class="btn-outline-grey"
                    variant="default"
                    to="sms-template"
                  >{{ $t('cancel') }}</b-button>-->
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 text-center">
            <button @click="onSaveBasicInfo()" class="btn btn-blue"
              >Save and Continue</button
            >
          </div>
        </div>
      </div>

      <!-- 02 MESSAGE -->
      <div class="col-12 rounded-10 border p-3 mb-4" v-if="sections.message">
        <div class="row">
          <div class="col-12">
            <div
              class="section-title text-uppercase mb-3"
              style="font-size:18px"
              >Message</div
            >
          </div>

          <div class="col-12 mb-4">
            <div class="rounded">
              <h6>Personalizing Content in Transactional Campaigns</h6>
              <p
                >Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto
                dolor quod rerum temporibus dicta vero voluptates sint quia
                aspernatur inventore? Ex, aut! Beatae dolor in, neque veniam
                consequuntur exercitationem unde. Lorem ipsum dolor sit amet,
                consectetur adipisicing elit. Doloribus fugiat saepe
                consequuntur, ipsum nulla incidunt atque eos tempora odit
                voluptatum sint illum quaerat! In aliquam error laudantium
                blanditiis delectus similique.</p
              >
            </div>
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">SMS Provider</div>
            <!-- <custommultiselect
              :options="arr"
              v-model="selected"
              placeholder="Sent To"
              label="cine_name"
              isSingleId="cine_id"
            ></custommultiselect>-->
            <!-- <select  @change="onChange($event)"> -->
            <multiselect
              v-model="selected_sms_provider"
              track-by="sp_name"
              label="sp_name"
              :options="sms_providers"
            ></multiselect>
            <p class="error_message">
              <span v-if="selected_sms_provider == null">{{
                "Please select email provider"
              }}</span>
            </p>
            <!-- {{selected_sms_provider}} -->
            <!-- <option
                v-for="(singleEmailProvider, providerIndex) in email_providers"
                :key="providerIndex"
                :value="singleEmailProvider.ep_id"
              >{{singleEmailProvider.ep_name}}</option>
            </select>-->
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">SMS Sender</div>
            <!-- <custommultiselect
              :options="selectUsers"
              placeholder="Select Sender"
              label="cine_name"
              isSingleId="cine_id"
            ></custommultiselect>-->
            <multiselect
              v-model="selected_sms_sender"
              label="ss_name"
              track-by="ss_name"
              :options="sms_senders"
            ></multiselect>
            <p class="error_message">
              <span v-if="selected_sms_sender == null">{{
                "Please select email sender"
              }}</span>
            </p>
            <!-- {{selected_sms_sender}} -->
          </div>

          <div class="col-lg-6">
            <div class="mb-2">Delivery Time</div>
            <div class="d-flex">
              <b-form-radio-group
                class="j-radio mb-3 mr-3"
                v-model="selected_radio_delivery"
                :options="optionsDelivery"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group>
              <!-- <b-form-radio class="j-radio mb-3">
                <div>Later</div>
              </b-form-radio>-->
            </div>
            <p class="error_message">
              <span v-if="selected_radio_delivery == ''">{{
                "Please select an option"
              }}</span>
            </p>
          </div>
          <div class="col-lg-6 mb-4">
            <div v-if="selected_radio_delivery !== 'Now'" class="mb-2"
              >Delivery Time</div
            >
            <div
              v-if="selected_radio_delivery !== 'Now'"
              class="input-material"
            >
              <div class="add-datepicker">
                <datetime
                  v-model="delivery_datetime"
                  type="datetime"
                  class="theme-custom-date-time"
                  format="yyyy-MM-dd hh:mm:ss a"
                  use12-hour
                ></datetime>
                <label v-if="delivery_datetime === ''"
                  >Select Date and Time</label
                >
              </div>
              <p class="error_message">
                <span v-if="delivery_datetime == ''">{{
                  "Please select Date and Time"
                }}</span>
              </p>
            </div>
            <!-- <div class="row">
              <div class="col-lg-2">
                <custommultiselect
                  :options="selectUsers"
                  placeholder="Weekly"
                  label="cine_name"
                  isSingleId="cine_id"
                ></custommultiselect>
              </div>

              <div class="col-lg-3">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="Sunday"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                  <div class="ml-3">on</div>
                </div>
              </div>

              <div class="col-lg-2">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="11"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                  <div class="ml-3">:</div>
                </div>
              </div>

              <div class="col-lg-2">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="30"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                </div>
              </div>

              <div class="col-lg-2">
                <div class="d-flex align-items-center w-100">
                  <custommultiselect
                    :options="selectUsers"
                    placeholder="AM"
                    label="cine_name"
                    isSingleId="cine_id"
                  ></custommultiselect>
                </div>
              </div>
            </div>-->
          </div>

          <!-- <div class="col-lg-6 mb-4">
            <div class="mb-2">DND</div>
            <div class="text-blue c-pointer small">SET DND HOURS</div>
          </div>-->

          <!-- <div class="col-lg-12 mb-4">
            <div class="mb-2">Throttling</div>
            <b-form-radio class="j-radio mb-4">
              <div>Do not throttle campaigns. Send all message immediately</div>
            </b-form-radio>

            <b-form-radio class="j-radio mb-3">
              <div>Throttle campaigns as per channel throttling limits</div>
            </b-form-radio>

            <div class="d-flex align-items-center">
              <b-form-radio class="j-radio">
                <div class="text-nowrap">Throttle campaigns at</div>
              </b-form-radio>
              <div class="input-material mx-2" style="width:100px">
                <input type="text" />
              </div>
              <div>message per minute</div>
            </div>
          </div>-->

          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromMessages()"
              >Back</router-link
            >
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSaveMessage()" class="btn btn-blue"
              >Save and Continue</button
            >
          </div>
        </div>
      </div>

      <!-- 03 CONVERSION TRACKING -->
      <div
        class="col-12 rounded-10 border p-3 mb-4"
        v-if="sections.conversionTracking"
      >
        <div class="row">
          <div class="col-12">
            <div
              class="section-title text-uppercase mb-3"
              style="font-size:18px"
              >Conversion Tracking</div
            >
          </div>

          <div class="col-lg-6 mb-4">
            <div class="mb-2">Converstion Event</div>
            <custommultiselect
              :options="selectUsers"
              placeholder="Select an Event"
              label="cine_name"
              isSingleId="cine_id"
            ></custommultiselect>
          </div>

          <div class="col-lg-6">
            <div class="mb-3">Enable conversion Tracking</div>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>

          <div class="col-lg-12 mb-4">
            <div class="mb-2">Converstion Deadline</div>
            <div class="row">
              <div class="col-2">
                <div class="input-material">
                  <input type="text" placeholder="." />
                  <label></label>
                </div>
              </div>
              <div class="col-2">
                <custommultiselect
                  :options="selectUsers"
                  placeholder="Months"
                  label="cine_name"
                  isSingleId="cine_id"
                ></custommultiselect>
              </div>
              <div class="col-4 align-self-center"
                >from delivery of message to user</div
              >
            </div>
          </div>

          <div class="col-12">
            <div class="mb-2">Control group(CG)</div>
            <b-form-checkbox class="j-checkbox mb-3">
              <div class="text-capitalize"
                >Add a control to measure effectiveness of campaign</div
              >
            </b-form-checkbox>
          </div>

          <div class="col-lg-12 mb-4">
            <div class="mb-2">Throttling</div>
            <b-form-radio class="j-radio mb-4">
              <div>Do not throttle campaigns. Send all message immediately</div>
            </b-form-radio>

            <b-form-radio class="j-radio mb-3">
              <div>Throttle campaigns as per channel throttling limits</div>
            </b-form-radio>

            <div class="d-flex align-items-center">
              <b-form-radio class="j-radio">
                <div class="text-nowrap">Throttle campaigns at</div>
              </b-form-radio>
              <div class="input-material mx-2" style="width:100px">
                <input type="text" />
              </div>
              <div>message per minute</div>
            </div>
          </div>

          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromConversionTracking()"
              >Back</router-link
            >
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSaveConversionTracking()" class="btn btn-blue"
              >Save and Continue</button
            >
          </div>
        </div>
      </div>

      <!-- 04 TEST CAMPAIGN -->
      <div
        class="col-12 rounded-10 border p-3 mb-4"
        v-if="sections.testCampaign"
      >
        <div class="row">
          <div class="col-12">
            <div
              class="section-title text-uppercase mb-3"
              style="font-size:18px"
              >Test Campaign</div
            >
            <div>
              Campaign Name:&nbsp;{{ campaign_name }}
              <br />
              Campaign Type:&nbsp;{{ selectedCampaignType.campaign_type_name }}
              <br />
              Audience:&nbsp;{{ selected_segment.segment_name }}
              <br />
              Campaign Start Date:&nbsp;{{ start_date }}
              <br />
              Campaign End Date:&nbsp;{{ end_date }}
              <br />
              Content Type:&nbsp;{{ selected_radio }}
              <br />
              SMS Template:&nbsp;{{ selected_sms_template.sms_temp_name }}
              <br />
              SMS Provider:&nbsp;{{ selected_sms_provider.sp_name }}
              <br />
              SMS Sender:&nbsp;{{ selected_sms_sender.ss_name }}
              <br />
              Delivery Date and Time:&nbsp;{{ show_delivery_date_time }}
              <br />
              Delivery Time:&nbsp;{{ selected_radio_delivery }}
              <br />
            </div>
          </div>
          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromTestCampaign()"
              >Back</router-link
            >
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSaveTestCampaign()" class="btn btn-blue"
              >Save and Continue</button
            >
          </div>
        </div>
      </div>

      <!-- 05 PREVIEW AND LAUNCH -->
      <div
        class="col-12 rounded-10 border p-3 mb-4"
        v-if="sections.previewAndLauch"
      >
        <div class="row">
          <div class="col-12">
            <div
              class="section-title text-uppercase mb-3"
              style="font-size:18px"
              >Preview and Launch</div
            >
          </div>
          <div class="col-lg-6 align-self-center">
            <router-link to @click.native="onBackFromPreviewAndLaunch()"
              >Back</router-link
            >
          </div>

          <div class="col-lg-6 text-right">
            <button @click="onSavePreviewAndLaunch()" class="btn btn-blue"
              >Save and Continue</button
            >
          </div>
        </div>
      </div>
    </div>

    <!-- SELECT CAMPAIGN TYPE MODAL -->
    <b-modal
      size="lg"
      class="modal-content"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      id="selectCampaignType"
      ref="selectCampaignType"
    >
      <!--<div class="col-12">-->
      <!--    <div class="text-center mb-4">-->
      <!--      <h5>Select Campaign Type</h5>-->
      <!--    </div>-->
      <!--  </div>-->
      <div
        class="modal-header position-relative w-100 d-flex align-items-start justify-content-center mb-3 pt-0 pl-0 pr-0"
      >
        <div class="">
          <h5>Select Campaign Type</h5>
        </div>
        <button
          type="button"
          style="right:0"
          class="close btn-clearDate position-absolute"
          v-on:click="hideModal('selectCampaignType')"
          >×</button
        >
      </div>
      <div class="row">
        <div
          v-for="(campaigntype, campaigntypeIndex) in campaign_types"
          :key="campaigntypeIndex"
          class="col-lg-3"
        >
          <div
            class="border text-center rounded p-3 h-100 c-pointer border-blue-hover"
            v-on:click="onSelectCampaignType(campaigntype)"
          >
            <h6>{{ campaigntype.campaign_type_name }}</h6>
            <p class="small mb-0">{{ campaigntype.campaign_type_desc }}</p>
          </div>
        </div>
        <!-- <div class="col-lg-3">
          <div
            class="border text-center rounded p-3 h-100 c-pointer border-blue-hover"
            v-on:click="onSelectCampaignType('Triggered')"
          >
            <h6>Triggered</h6>
            <p class="small p-0">Send the campaign on the occurrence of a custom event</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div
            class="border text-center rounded p-3 h-100 c-pointer border-blue-hover"
            v-on:click="onSelectCampaignType('Recurring')"
          >
            <h6>Recurring</h6>
            <p class="small mb-0">Schedule the campaign to be sent at regular intervals</p>
          </div>
        </div>
        <div class="col-lg-3 text-center" v-on:click="onSelectCampaignType('Transactional')">
          <div class="border text-center rounded p-3 h-100 c-pointer border-blue-hover">
            <h6>Transactional</h6>
            <p class="small mb-0">Send critical messages throughout the transactional API</p>
          </div>
        </div>-->
      </div>
    </b-modal>
  </div>
</template>

<script>
  import MarketingAutomation from "@/services/MarketingAutomationService";
  import moment from "moment";

  export default {
    data() {
      return {
        submitted3: false,
        sms_template_insert_id: 0,
        keys: [],
        submittedtemplate: false,
        sms_temp_is_active: true,
        sms_template_content: "",
        sms_temp_name: "",
        sms_title: "",
        selected_sms_template: null,
        smstemplateList: [],
        date_checker: false,
        campaign_details: "",
        campaign_types: [],
        sms_providers: [],
        selected_sms_provider: {
          sp_id: 0,
          sp_name: "",
        },
        sms_senders: [],
        selected_sms_sender: {
          ss_id: 0,
          ss_name: "",
        },
        segments: [],
        selected_segment: {
          s_id: 0,
          segment_name: "",
        },
        campaign_name: "",
        campaign_start_date: "",
        campaign_end_date: "",
        sms_message: "",
        options: [
          {
            item: "Promotional",
            name: "Promotional (send only to subscribed user in Audience)",
          },
          {
            item: "Transactional",
            name:
              "Transactional(send to all users in Audience including those who have unsubscribed)",
          },
        ],
        selected_radio: "",
        delivery_datetime: "",
        optionsDelivery: [
          {
            item: "Now",
            name: "Now",
          },
          {
            item: "Later",
            name: "Later",
          },
        ],
        selected_radio_delivery: "",
        sections: {
          basicInfo: true,
          message: false,
          conversionTracking: false,
          testCampaign: false,
          previewAndLauch: false,
        },
        selectedCampaignType: {
          campaign_type_name: "",
          ct_id: 0,
        },
        selectUsers: ["All Users", "Selected Users"],
        token: 0,
      };
    },
    watch: {
      selected_radio_delivery: function(newVal) {
        if (newVal == "Now") {
          this.delivery_datetime = moment().format("YYYY-MM-DD HH:mm:ss");
        }
      },
      campaign_start_date: function(newVal) {
        console.log("newVal :", newVal);
        if (newVal) {
          let start = moment(this.campaign_start_date).format();
          let end = moment(this.campaign_end_date).format();
          if (start > end) {
            this.date_checker = true;
          } else {
            this.date_checker = false;
          }
        }
      },
      campaign_end_date: function(newVal) {
        if (newVal) {
          let start = moment(this.campaign_start_date).format();
          let end = moment(this.campaign_end_date).format();
          if (start < end) {
            this.date_checker = false;
          } else {
            this.date_checker = true;
          }
        }
      },
    },
    computed: {
      start_date() {
        return moment(this.campaign_start_date).format("MMMM Do YYYY");
      },
      end_date() {
        return moment(this.campaign_end_date).format("MMMM Do YYYY");
      },
      show_delivery_date_time() {
        return moment(this.delivery_datetime, "YYYY-MM-DD HH:mm:ss").format(
          "MMMM Do YYYY,  h:mm:ss a "
        );
      },
    },
    methods: {
      hideModal: function(modal) {
        if (modal == "selectCampaignType") {
          this.$bvModal.hide("selectCampaignType");
        }
      },
      onResetForm: function() {
        this.submitted3 = false;
        this.sms_template_content = "";
        this.sms_temp_name = "";
        this.sms_temp_is_active = true;
      },
      OnFinalSubmit: function() {
        this.submitted3 = true;
        if (this.sms_temp_name !== "" && this.sms_template_content !== "") {
          let payload = {
            sms_name: this.sms_temp_name,
            content: this.sms_template_content,
            sms_is_active: this.sms_temp_is_active,
          };

          MarketingAutomation.AddSmsTemplate(payload)
            .then((response) => {
              const { data } = response;

              if (data && data.status) {
                this.submitted3 = false;
                this.submittedtemplate = true;
                this.sms_template_insert_id = data.Records;
                console.log(
                  "this.sms_template_insert_id :",
                  this.sms_template_insert_id
                );
                this.$toasted.show("Template added and selected successfully");
                // this.$router.push({
                //   path: "/master/sms-template"
                // });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          this.$toasted.show("Enter all template details");
        }
      },
      getSmsTemplateList: function() {
        let body = {
          limit: this.perPage,
          currentPage: this.currentPage,
        };
        MarketingAutomation.GetSmsTemplates()
          .then((response) => {
            const { data } = response;

            if (data && data.status) {
              if (data.Records && data.Records.length > 0) {
                this.smstemplateList = data.Records;
                this.smstemplateList.push({
                  sms_temp_name: "Custom Template",
                  sms_id: 0,
                });
                console.log("this.emailtemplateList :", this.emailtemplateList);
              }
            }
          })
          .catch(this._CatchError);
      },
      getSmsCampaignDetails(payload) {
        MarketingAutomation.getSmsCampaignDetails({ sc_id: payload.sc_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.campaign_details = data.Records[0];
              console.log("this.campaign_details :", this.campaign_details);
              this.campaign_name = this.campaign_details.campaign_name;
              this.selectedCampaignType.campaign_type_name = this.campaign_details.campaign_type_name;
              this.selectedCampaignType.ct_id = this.campaign_details.ct_id;
              this.selected_segment.segment_name = this.campaign_details.segment_name;
              this.selected_segment.s_id = this.campaign_details.s_id;
              this.campaign_start_date = this.campaign_details.campaign_start_date;
              this.campaign_end_date = this.campaign_details.campaign_end_date;
              this.selected_sms_template = {
                sms_id: this.campaign_details.sms_id,
                sms_temp_name: this.campaign_details.sms_temp_name,
              };
              if (this.campaign_details.sp_id !== null) {
                this.selected_sms_provider.sp_id = this.campaign_details.sp_id;
                this.selected_sms_provider.sp_name = this.campaign_details.sp_name;
              } else {
                this.selected_sms_provider = null;
                console.log(
                  " this.selected_sms_provider:",
                  this.selected_sms_provider
                );
              }
              if (this.campaign_details.ss_id !== null) {
                this.selected_sms_sender.ss_id = this.campaign_details.ss_id;
                this.selected_sms_sender.ss_name = this.campaign_details.ss_name;
              } else {
                this.selected_sms_sender = null;
              }

              if (this.campaign_details.date_time) {
                this.delivery_datetime = moment
                  .unix(this.campaign_details.date_time)
                  .format();
              }

              if (this.campaign_details.is_promotional == "Y") {
                this.selected_radio = "Promotional";
              } else {
                this.selected_radio = "Transactional";
              }
              if (this.campaign_details.is_send_now !== null) {
                if (this.campaign_details.is_send_now == "Y") {
                  this.selected_radio_delivery = "Now";
                } else {
                  this.selected_radio_delivery = "Later";
                }
              }
              if (this.selectedCampaignType.campaign_type_name == null) {
                this.$refs["selectCampaignType"].show();
              }
            } else {
              this.selected_segment = null;
              this.selected_sms_sender = null;
              this.selected_sms_provider = null;

              this.$refs["selectCampaignType"].show();

              // this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getCampaignTypes() {
        MarketingAutomation.getCampaignTypes()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              console.log("mydata :", data);
              this.campaign_types = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getSMSProviders() {
        MarketingAutomation.getSMSProviders()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.sms_providers = data.Records;

              console.log("this.sms_providers :", this.sms_providers);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getSMSSenders() {
        MarketingAutomation.getSMSSenders()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.sms_senders = data.Records;

              console.log("this.sms_senders :", this.sms_senders);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getSegments() {
        MarketingAutomation.getSegments()
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.segments = data.Records;

              console.log("this.segments :", this.segments);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      editSmsCampaignBasic(payload) {
        let sms_id = payload;
        const { sc_id } = this.$route.params;
        MarketingAutomation.editSmsCampaignBasic({
          sc_id: sc_id,
          campaign_name: this.campaign_name,
          campaign_type_id: this.selectedCampaignType.ct_id,
          segment_id: this.selected_segment.s_id,
          campaign_start_date: this.campaign_start_date,
          campaign_end_date: this.campaign_end_date,
          content_type: this.selected_radio,
          sms_id: sms_id,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              // this.$toasted.show(data.message);
              this.sections.basicInfo = false;
              this.sections.message = true;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      editSmsCampaignMessage() {
        const { sc_id } = this.$route.params;

        MarketingAutomation.editSmsCampaignMessage({
          sc_id: sc_id,
          sp_id: this.selected_sms_provider.sp_id,
          ss_id: this.selected_sms_sender.ss_id,
          delivery: this.selected_radio_delivery,
          delivery_datetime: this.delivery_datetime,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              // this.$toasted.show(data.message);
              this.sections.message = false;
              this.sections.testCampaign = true;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      finalEditSmsCampaign() {
        const { sc_id } = this.$route.params;

        MarketingAutomation.finalEditSmsCampaign({
          sc_id: sc_id,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
              this.$router.push({ name: "SMS Campaigns" });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      editCampaign() {
        const { ec_id } = this.$route.params;
        MarketingAutomation.editCampaign({
          ec_id: ec_id,
          campaign_name: this.campaign_name,
          campaign_type_id: this.selectedCampaignType.ct_id,
          segment_id: this.selected_segment.s_id,
          campaign_start_date: this.campaign_start_date,
          campaign_end_date: this.campaign_end_date,
          content_type: this.selected_radio,
          sms_message: this.sms_message,
          sp_id: this.selected_sms_provider.sp_id,
          ss_id: this.selected_sms_sender.ss_id,
          delivery: this.selected_radio_delivery,
          delivery_datetime: this.delivery_datetime,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$router.push({ name: "Email Campaigns" });
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectCampaignType(selection) {
        this.selectedCampaignType = selection;
        this.$refs["selectCampaignType"].hide();
      },
      selectCampaignTypeModal() {
        this.$refs["selectCampaignType"].show();
      },
      onSaveBasicInfo() {
        this.$validator.validate().then(async (valid) => {
          if (
            valid &&
            this.campaign_start_date !== "" &&
            this.campaign_end_date !== "" &&
            this.selected_radio !== "" &&
            this.selected_sms_template
          ) {
            if (this.campaign_end_date > this.campaign_start_date) {
              if (this.selected_sms_template.sms_id !== 0) {
                await this.editSmsCampaignBasic(
                  this.selected_sms_template.sms_id
                );
              } else if (
                this.selected_sms_template.sms_id == 0 &&
                this.sms_template_insert_id !== 0
              ) {
                //code here
                await this.editSmsCampaignBasic(this.sms_template_insert_id);
              } else {
                this.$toasted.show("Please create the custom template");
              }
            } else {
              this.$toasted.show("End Date cannot be smaller than Start Date");
            }
          } else {
            this.$toasted.show("Please enter all details");
          }
        });

        // this.sections.basicInfo = false;
        // this.sections.message = true;
      },
      onSaveMessage: function() {
        if (
          this.selected_sms_provider !== null &&
          this.selected_sms_sender !== null &&
          this.selected_radio_delivery != ""
        ) {
          if (this.selected_radio_delivery == "Now") {
            this.editSmsCampaignMessage();
          } else {
            if (this.delivery_datetime !== "") {
              this.editSmsCampaignMessage();
            } else {
              this.$toasted.show("Please select delivery date and time");
            }
          }
        } else {
          this.$toasted.show("Please enter all details");
        }

        // this.sections.message = false;
        // this.sections.testCampaign = true;
        // this.sections.conversionTracking = true;
      },
      onSaveConversionTracking: function() {
        this.sections.conversionTracking = false;
        this.sections.testCampaign = true;
      },
      onSaveTestCampaign: function() {
        this.sections.testCampaign = false;
        this.sections.previewAndLauch = true;
      },
      onBackFromMessages: function() {
        this.sections.message = false;
        this.sections.basicInfo = true;
      },
      onBackFromConversionTracking: function() {
        this.sections.conversionTracking = false;
        this.sections.message = true;
      },
      onBackFromTestCampaign: function() {
        this.sections.testCampaign = false;
        // this.sections.conversionTracking = true;
        this.sections.message = true;
      },
      onBackFromPreviewAndLaunch: function() {
        this.sections.previewAndLauch = false;
        this.sections.testCampaign = true;
      },
      onSavePreviewAndLaunch: function() {
        // this.sections.testCampaign = false;
        // this.sections.previewAndLauch = true;
        // this.editCampaign();
        this.finalEditSmsCampaign();
      },
    },

    beforeMount() {
      const { sc_id } = this.$route.params;
      console.log("sc_id :", sc_id);
      if (sc_id) {
        this.getSmsCampaignDetails({ sc_id: sc_id });
      } else {
        this.$router.go(-1);
      }
    },
    mounted() {
      // this.$refs["selectCampaignType"].show();
      this.getSmsTemplateList();
      this.getCampaignTypes();
      this.getSMSProviders();
      this.getSMSSenders();
      this.getSegments();
    },
  };
</script>

<style>
  .campaign-step {
    width: 100%;
    text-align: center;
    position: relative;
    border-bottom: 3px solid transparent;
  }

  .campaign-step:not(:last-child)::after {
    top: -5px;
    right: -12.5px;
    content: "→";
    display: block;
    font-size: 20px;
    position: absolute;
  }

  .campaign-step.active {
    border-color: var(--lightgrey);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/SmsComponents/editSmsCampaign.vue